// DatePickers from mui-x breaks when dayjs objectSupport plugin is used:
// https://github.com/mui/mui-x/issues/7571
// Workaround available with an extra plugin that converts null to NaN
// https://github.com/iamkun/dayjs/issues/2208#issuecomment-1521683665

const dayjsNullSupport = (_options: any, dayjsClass: any) => {
  const oldParse = dayjsClass.prototype.parse
  dayjsClass.prototype.parse = function (config: any) {
    if (config.date === null) {
      config.date = NaN
    }
    oldParse.bind(this)(config)
  }
}

export default dayjsNullSupport
